import { ServiceLocationType } from '@/calendesk/models/DTO/Response/ServiceLocationType'

export default class ServiceLocation {
  public id!: number
  public type!: ServiceLocationType
  public data!: string | null
}
